/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Sort_Last_ActivityInputs */



/**
* | output |
* | --- |
* | "Last Activity" |
*
* @param {Project_Sort_Last_ActivityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_sort_last_activity = /** @type {((inputs?: Project_Sort_Last_ActivityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Sort_Last_ActivityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Aktivität")
	return /** @type {LocalizedString} */ ("Last Activity")
});